



































































































































    import { Vue,Component } from 'vue-property-decorator'
    import { State,Action,namespace,Mutation } from 'vuex-class'
    // import Partner from '../../components/partner.vue'
    import exicon from '../../assets/js/expressicon'
    import dayjs from 'dayjs'
    const basis = namespace('basis')
    @Component({
        components: {
            // Partner
        }
    })
    export default class Packageslist extends Vue{
        site:string = ''
        exicon:any = exicon
        @basis.State('deliveryPager') pager:any
        @basis.State('deliveryList') packagesList:any
        @basis.State('loading') loading:any
        time:any = []
        partner:string = ''
        searchStatus:string = '' //派件状态
        pachagesInfo:Boolean = false //快递订单详情弹窗
        pachagesInfoLoading:boolean = false
        orderInfo:any = null //快递订单详情
        lookInfoId:string = '' //查看单号详情ID
        get search() {
            let start = ''
            let end = ''
            if(this.time){
                start = this.time[0]
                end = this.time[1]
            }
            return {
                site: this.site, //选择网点
                secret: '', //取件码
                code: '', //单号
                phone: '', // 电话
                start: start, //开始日期
                end: end, //结束日期
                status: this.searchStatus, //派件状态
                partner: this.partner, //快递员
                page: 1
            }
        }
        get tablecolumn(){
            return [
                {
                    prop: 'code',
                    name: 'code',
                    type: 'slot',
                    label: '快递单号',
                },
                {
                    prop: 'shelf',
                    nextProp: 'name',
                    type: 'nextProp',
                    label: '货架'
                },
                {
                    prop: 'serial',
                    type: 'text',
                    label: '编号'
                },
                {
                    prop: 'phone',
                    type: 'text',
                    label: '电话'
                },
                {
                    prop: 'partner',
                    name: 'partner',
                    type: 'slot',
                    label: '快递员'
                },
                {
                    prop: 'intime',
                    type: 'text',
                    label: '入库时间'
                },
                {   prop: 'outtime',
                    name: 'outtime',
                    type: 'slot',
                    label: '出库时间'
                },
                {   prop: 'status',
                    name: 'status',
                    type: 'slot',
                    label: '状态'
                },
                {   prop: 'mtype',
                    name: 'mtype',
                    type: 'slot',
                    label: '短信'
                },
                {
                    prop: 'desc',
                    type: 'text',
                    label: '备注'
                }
            ]
        }
        @basis.Action('getDeliveryList') getPackagesList:any
        @basis.Action('importDeliveryFun') importDeliveryFun:any
        @basis.Action('getCodeInfo') getCodeInfo:any //获得快递详情
        @basis.Action('inboundPachages') inboundPachages:any
        created(){
            this.getList()
        }
        getList(){
            console.log(this.time);
            console.log(this.search);
            
            this.getPackagesList(this.search)
        }
        // 翻页
        pagechange(e:any){
            this.search.page = e[0].val
            this.getList()
        }
        // 点击查询按钮
        queryData(val:string){
            this.search.page = 1;
            this.getList()
        }
        // 网点改变的时候
        changeSite(val:string){
            this.site = val
            this.getList()
        }
        // 导入派件
        async importDelivery(){
            await this.importDeliveryFun({
                site: this.search.site
            })
            this.getList()
        }
        // 查看快递订单详细信息
        async lookInfo(id:string){
            this.pachagesInfo = true;
            this.lookInfoId = id;
            this.pachagesInfoLoading = true;
            const res = await this.getCodeInfo(id)
	        res.intime = dayjs(res.intime).format('YYYY-MM-DD HH:mm:ss');
	        res.outtime = res.outtime ? dayjs(res.outtime).format('YYYY-MM-DD HH:mm:ss') : '暂无';
            this.orderInfo = res;
            this.pachagesInfoLoading = false;
        }
        // 入站
        async inbound(type:string){
            const res = await this.inboundPachages({
                id: this.lookInfoId,
                type: type
            })
        }
    }
